var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Discord",
    clipPath: "url(#clip0_8673_1578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0959 0.658691H4.30597C2.14547 0.658691 0.394043 2.41012 0.394043 4.57062V18.3606C0.394043 20.5211 2.14547 22.2725 4.30597 22.2725H18.0959C20.2564 22.2725 22.0079 20.5211 22.0079 18.3606V4.57062C22.0079 2.41012 20.2564 0.658691 18.0959 0.658691Z",
    fill: "url(#paint0_linear_8673_1578)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0086 18.3604V12.2932C20.1733 10.413 18.2875 8.59457 16.4522 6.71438C15.4588 6.25976 14.4092 5.93424 13.3316 5.74902C13.1969 5.99036 13.0398 6.31028 12.9331 6.56845C11.906 6.41691 10.8677 6.40569 9.84064 6.52916C9.57685 6.28783 9.31306 6.03526 9.06611 5.74902C7.9885 5.93424 6.93896 6.25976 5.94555 6.71999C3.97555 9.65534 3.44236 12.5233 3.70615 15.3464C6.04096 17.642 8.32525 19.9712 10.6488 22.2779H18.0967C20.2463 22.2779 22.0086 20.5156 22.0086 18.366V18.3604Z",
    fill: "#5569F5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4522 6.66408C15.4588 6.20947 14.4092 5.88394 13.3316 5.69873C13.1969 5.94007 13.0398 6.25998 12.9331 6.51816C11.7882 6.34978 10.6208 6.34978 9.47582 6.51816C9.35235 6.23753 9.21764 5.96252 9.06611 5.69873C7.9885 5.88394 6.93896 6.20947 5.94554 6.6697C3.97555 9.60505 3.44236 12.473 3.70615 15.2961C4.86233 16.1549 6.15882 16.8115 7.53389 17.2269C7.84258 16.8059 8.11759 16.3625 8.35332 15.8967C7.90431 15.7283 7.47215 15.5206 7.06244 15.2793C7.16907 15.2007 7.27571 15.1165 7.37674 15.0324C9.80135 16.1773 12.6132 16.1773 15.0322 15.0324C15.1332 15.1165 15.2399 15.2007 15.3465 15.2793C14.9368 15.5263 14.499 15.7283 14.0556 15.8967C14.2914 16.3625 14.5664 16.8059 14.8751 17.2269C16.2557 16.8059 17.5466 16.1549 18.7028 15.2961C19.0171 12.024 18.164 9.18411 16.4522 6.66408ZM8.68446 13.5619C7.93799 13.5619 7.32623 12.8771 7.32623 12.0409C7.32623 11.2046 7.92676 10.5143 8.68446 10.5143C9.44215 10.5143 10.0539 11.199 10.0427 12.0409C10.0371 12.8828 9.44215 13.5675 8.68446 13.5675V13.5619ZM13.7133 13.5619C12.9668 13.5619 12.355 12.8771 12.355 12.0409C12.355 11.2046 12.9556 10.5143 13.7133 10.5143C14.471 10.5143 15.0827 11.199 15.0715 12.0409C15.0659 12.8828 14.471 13.5675 13.7133 13.5675V13.5619Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8673_1578",
    x1: 1.54461,
    y1: 1.80926,
    x2: 20.8573,
    y2: 21.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#566AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C44B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8673_1578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6138,
    height: 21.6138,
    fill: "white",
    transform: "translate(0.394043 0.658691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8162a4e992acd86dcb0e9b04a62ac1e3.svg";
export { ForwardRef as ReactComponent };